import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';

/**
 * Panel superadmin — llama Cloud Functions del core (`adminPlan.js`).
 * El cliente NUNCA escribe plan/subscriptionStatus (Firestore Rules lo bloquean).
 *
 * Al cambiar plan solo se modifica: users/{id}
 * Al suspender cuenta solo se modifica: users/{id}
 */

/**
 * Mapeo EXACTO que espera getSubscriptionState (app) y emissionAuthorization (CF).
 * Pro usa subscriptionStatus 'premium' por convención legacy del core.
 */
export const PLAN_OPTIONS = [
  {
    id: 'free',
    label: 'Free (sin plan)',
    plan: 'free',
    subscriptionStatus: 'free',
    access: 'Sin emisión ni inventario',
  },
  {
    id: 'trial',
    label: 'Trial (7 días)',
    plan: 'trial',
    subscriptionStatus: 'trial',
    access: 'Acceso Premium-like 7 días',
  },
  {
    id: 'basic',
    label: 'Básico',
    plan: 'basic',
    subscriptionStatus: 'basic',
    access: '100 comprobantes/mes · sin inventario completo',
  },
  {
    id: 'pro',
    label: 'Pro',
    plan: 'pro',
    subscriptionStatus: 'premium',
    access: 'Ilimitado + inventario · sin compras/PLE (solo Premium)',
  },
  {
    id: 'premium',
    label: 'Premium',
    plan: 'premium',
    subscriptionStatus: 'premium',
    access: 'Ilimitado + inventario + compras + PLE',
  },
];

export async function adminSearchUsers(q = '') {
  const fn = httpsCallable(functions, 'adminSearchUsers');
  const result = await fn({ q });
  return result?.data?.users || [];
}

export async function grantAdminPlan({ email, dni, uid, ruc, plan, expiryDate, trialDays }) {
  const fn = httpsCallable(functions, 'grantAdminPlan');
  const result = await fn({ email, dni, uid, ruc, plan, expiryDate, trialDays });
  return result?.data;
}

/** Suspender (active=false) o reactivar (active=true) la cuenta. */
export async function suspendAdminAccount({ email, dni, uid, ruc, active, reason }) {
  const fn = httpsCallable(functions, 'suspendAdminAccount');
  const result = await fn({ email, dni, uid, ruc, active, reason });
  return result?.data;
}

export async function setSuperAdminClaim({ email, uid }) {
  const fn = httpsCallable(functions, 'setSuperAdminClaim');
  const result = await fn({ email, uid });
  return result?.data;
}

export function hasSuperadminClaim(tokenResult) {
  return tokenResult?.claims?.superadmin === true;
}
